export const AUTH_LANGUAGES = ["en", "nl"];

export const AUTH_ROUTE_NAMES = ["login", "password-reset", "reset-password"];

export const normalizeAuthLang = (lang) =>
  AUTH_LANGUAGES.includes(lang) ? lang : "en";

export const getStoredAuthLang = () =>
  normalizeAuthLang(localStorage.getItem("authLang"));

export const storeAuthLang = (lang) => {
  localStorage.setItem("authLang", normalizeAuthLang(lang));
};

/** e.g. /login/nl -> /login/en, /password-reset -> /password-reset/nl */
export const replaceLangInAuthPath = (pathname, lang) => {
  const normalized = normalizeAuthLang(lang);
  const parts = pathname.split("/").filter(Boolean);

  if (parts.length === 0 || !AUTH_ROUTE_NAMES.includes(parts[0])) {
    return `/login/${normalized}`;
  }

  const routeName = parts[0];

  if (parts.length === 1) {
    return `/${routeName}/${normalized}`;
  }

  if (AUTH_LANGUAGES.includes(parts[1])) {
    parts[1] = normalized;
  } else {
    parts.splice(1, 0, normalized);
  }

  return `/${parts.join("/")}`;
};

export const authPath = (routeName, lang) =>
  `/${routeName}/${normalizeAuthLang(lang)}`;

/** Resolve lang from query (?lang=), path param, i18n, or localStorage; default en. */
export const resolveAuthLang = ({ langParam, search, i18nLang } = {}) => {
  const fromQuery = new URLSearchParams(search || "").get("lang");
  if (fromQuery) return normalizeAuthLang(fromQuery);
  if (langParam) return normalizeAuthLang(langParam);
  if (i18nLang) return normalizeAuthLang(i18nLang);
  return getStoredAuthLang();
};

/** Redirect target for bare auth paths; keeps email link query params (token, email, etc.). */
export const authRedirectTarget = (basePath, location) => {
  const lang = resolveAuthLang({ search: location.search });
  return `${basePath}/${lang}${location.search}${location.hash || ""}`;
};
